import React from "react";
import RecordVoiceOver from "@material-ui/icons/RecordVoiceOver";
import PlayCircleOutline from "@material-ui/icons/PlayCircleOutline";
import LinkIcon from "@material-ui/icons/Link";
import Dialpad from "@material-ui/icons/Dialpad";
import MusicNote from "@material-ui/icons/MusicNote";
import AccountTree from "@material-ui/icons/AccountTree";
import CallSplit from "@material-ui/icons/CallSplit";
import TrendingFlat from "@material-ui/icons/TrendingFlat";
import Schedule from "@material-ui/icons/Schedule";
import PhoneForwarded from "@material-ui/icons/PhoneForwarded";
import Group from "@material-ui/icons/Group";
import AddIcCall from "@material-ui/icons/AddIcCall";
import Hearing from "@material-ui/icons/Hearing";
import Call from "@material-ui/icons/Call";
import CallEnd from "@material-ui/icons/CallEnd";
import PlaylistAdd from "@material-ui/icons/PlaylistAdd";
import PlaylistPlay from "@material-ui/icons/PlaylistPlay";
import ExitToApp from "@material-ui/icons/ExitToApp";
import Http from "@material-ui/icons/Http";
import Reply from "@material-ui/icons/Reply";
import Code from "@material-ui/icons/Code";
import Save from "@material-ui/icons/Save";
import Storage from "@material-ui/icons/Storage";
import Image from "@material-ui/icons/Image";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import Chat from "@material-ui/icons/Chat";
import Forum from "@material-ui/icons/Forum";
import Mic from "@material-ui/icons/Mic";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Tune from "@material-ui/icons/Tune";
import NotificationsActive from "@material-ui/icons/NotificationsActive";
import EmojiObjects from "@material-ui/icons/EmojiObjects";
import Settings from "@material-ui/icons/Settings";
import Loop from "@material-ui/icons/Loop";
import LoopEnd from "@material-ui/icons/SubdirectoryArrowLeft";

import ConnectorIcon from "../Connectors/ConnectorIcon";
import { byType as connByType } from "../Connectors/catalog";
import { connectorTypeOf } from "./verbs";

// One icon per component. Brand connectors use their logo (ConnectorIcon); core
// verbs map to a Material icon (with a per-category fallback so EVERY node has an
// icon). Rendered in a colored rounded square matching the node colour.
const MAP = {
  say: RecordVoiceOver,
  play: PlayCircleOutline,
  pause: PlayCircleOutline,
  dtmf: Dialpad,
  dub: MusicNote,
  gather: Dialpad,
  ivr: AccountTree,
  branch: CallSplit,
  redirect: TrendingFlat,
  schedule: Schedule,
  dial: PhoneForwarded,
  ring_group: Group,
  originate: AddIcCall,
  detect_answer: Hearing,
  answer: Call,
  hangup: CallEnd,
  "sip:decline": CallEnd,
  "sip:refer": PhoneForwarded,
  conference: Group,
  enqueue: PlaylistAdd,
  dequeue: PlaylistPlay,
  leave: ExitToApp,
  http_request: Http,
  http_response: Reply,
  loop: Loop,
  loop_end: LoopEnd,
  code: Code,
  data_set: Save,
  data_get: Storage,
  record_save: Storage,
  record_query: Storage,
  code_job_run: Code,
  public_link: LinkIcon,
  read_pdf: PictureAsPdf,
  ai_prompt: EmojiObjects,
  ai_read_image: Image,
  ai_read_pdf: PictureAsPdf,
  llm: Chat,
  transcribe: Forum,
  listen: Mic,
  tag: LocalOffer,
  config: Tune,
  alert: NotificationsActive,
};

const CAT_FALLBACK = {
  audio: RecordVoiceOver,
  input: Dialpad,
  routing: CallSplit,
  call: Call,
  queue: Group,
  ai: EmojiObjects,
  advanced: Settings,
  data: Storage,
  connectors: Settings,
};

// ícone por TIPO de gatilho (o nó de gatilho não tem verbKey de verbo)
const TRIG_MAP = {
  inbound_call: Call,
  api_call: Call,
  webhook: Http,
  scheduled: Schedule,
};
const triggerIcon = triggerType =>
  TRIG_MAP[triggerType] || (String(triggerType || "").startsWith("event.") ? NotificationsActive : NotificationsActive);

// #RRGGBB -> rgba(r,g,b,a) (p/ o fundo do chip a ~13% da cor da categoria)
const hexToRgba = (hex, a) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ""));
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

// Sistema de nós (refactor): card neutro + COR só no chip. `chip` => fundo a ~13%
// da cor + ícone na cor cheia (canvas). Sem `chip` => quadrado sólido + ícone
// branco (paleta/menus). `triggerType` escolhe o ícone do nó de gatilho.
const NodeIcon = ({ verbKey, triggerType, category, color = "#5F5E5A", size = 30, brand, chip }) => {
  const ct = brand || connectorTypeOf(verbKey);
  if (ct) {
    const meta = connByType(ct) || {};
    return <ConnectorIcon icon={meta.icon} name={meta.name || ct} color={meta.color || color} size={size} />;
  }
  const Ico = triggerType ? triggerIcon(triggerType) : MAP[verbKey] || CAT_FALLBACK[category] || Settings;
  if (chip) {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: 8,
          background: hexToRgba(color, 0.13),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Ico style={{ color, fontSize: Math.round(size * 0.57) }} />
      </div>
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 8,
        background: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Ico style={{ color: "#fff", fontSize: Math.round(size * 0.58) }} />
    </div>
  );
};

export default NodeIcon;
